export const getFillColor = (
  colorConfig: { color: string; opacity: number } | undefined,
  fallback: string,
) => {
  if (!colorConfig) return fallback
  return colorConfig.opacity === 1
    ? `var(--${colorConfig.color})`
    : `color-mix(in srgb, var(--${colorConfig.color}) ${colorConfig.opacity * 100}%, transparent)`
}

export const getChartPalette = (
  palette: "primary" | "support",
  mode: "stack" | "sequence",
  n: number,
) => {
  const color1 = palette === "primary" ? "chart-1" : "support-primary"
  const color2 = palette === "primary" ? "chart-2" : "support-secondary"
  const color3 = palette === "primary" ? "chart-3" : "testing-3"
  const color4 = palette === "primary" ? "chart-4" : "testing-2"

  const baseColors =
    mode === "stack" ? [color1, color2, color3, color4] : [color1, color3, color2, color4]

  const colors: Array<{ color: string; opacity: number }> = []
  for (let i = 0; i < n; i += 1) {
    if (i < 4) {
      // Base colors (full opacity)
      colors.push({
        color: baseColors[i] ?? "muted",
        opacity: 1,
      })
    } else if (i < 8) {
      // First opacity reduction
      const baseIndex = i % 4
      colors.push({
        color: baseColors[baseIndex] ?? "muted",
        opacity: 0.8,
      })
    } else if (i < 12) {
      // Second opacity reduction
      const baseIndex = i % 4
      colors.push({
        color: baseColors[baseIndex] ?? "muted",
        opacity: 0.5,
      })
    } else {
      // After 12 colors, use muted
      colors.push({
        color: "muted",
        opacity: 1,
      })
    }
  }

  return colors
}

export const getMixedPalette = (isSupport?: boolean, noSlice?: boolean) => {
  const refPalette = [
    "chart-primary",
    "chart-secondary",
    "chart-2",
    "chart-3",
    "chart-1",
    "chart-4",
    "testing-2",
    "testing-3",
    "support-secondary",
    "support-primary",
  ]

  const palette = isSupport ? refPalette.reverse() : refPalette

  if (noSlice) {
    return palette
  }

  return [...palette.slice(0, 8)]
}

const flagsPalette = [
  "var(--testing-2)",
  "var(--testing-3)",
  "var(--neutral)",
  "var(--negative-soft)",
  "var(--negative)",
  "var(--support-primary)",
  "var(--support-secondary)",
  "var(--warning)",
]

export const getFlagsPalette = (count = flagsPalette.length) =>
  Array.from({ length: count }, (_, index) => {
    return flagsPalette[index] ?? "color-mix(in srgb, var(--chart-2) 40%, transparent)"
  })
